import axios from 'axios'
import base_url from '../base_url.js'

let Base = axios.create({
    baseURL: base_url+'api/v1/',
})

export default Base